import React, { Component } from 'react';
import ArticlesCards from './ArticlesCards.jsx';
import arrow from '../../../assets/images/icons/arrow-white.svg';

class ArticlesCardsList extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className=''>
                {this.props.articles === undefined ? (
                    <></>
                ) : (
                    <ArticlesCards
                        size={this.props.size}
                        articles={this.props.articles}
                        small={this.props.small}
                        nowrap={this.props.nowrap}
                        className='row'
                    />
                )}
            </div>
        );
    }
}

export default ArticlesCardsList;
